'use strict';

const React = require('react');
const ReactDOM = require('react-dom');
const {provideContext, connectToStores} = require('fluxible-addons-react');

const User = require('./models/User');
const TradeWelcomeMessage = require('./components/TradeWelcomeMessage/TradeWelcomeMessage');
const TradeMessageStore = require('./stores/TradeMessageStore');
const UserStore = require('./stores/UserStore');

module.exports = {
    initWelcomeMessage(context) {
        const userStore = context.getStore(UserStore);
        this.onUserStoreChange = this.onUserStoreChange.bind(this, context);
        userStore.addChangeListener(this.onUserStoreChange);
    },

    onUserStoreChange(context) {
        const tradeMessageStore = context.getStore(TradeMessageStore);
        const userStore = context.getStore(UserStore);
        const tradeSalesRep = userStore.getTradeSalesRep();

        if (tradeMessageStore.canShowMessage && tradeSalesRep) {
            this.renderMessage(context);
            userStore.removeChangeListener(this.onUserStoreChange);
        }
    },

    renderMessage(context) {
        const tradeMessageStore = context.getStore(TradeMessageStore);
        const userStore = context.getStore(UserStore);
        const tradeSalesRep = userStore.getTradeSalesRep();

        const currentUser = User.getCurrentUser();
        const element = document.createElement('div');
        document.body.appendChild(element);

        const component = provideContext(connectToStores(TradeWelcomeMessage, [TradeMessageStore], () => {
            return {
                tradeSalesRep,
                userFirstName: currentUser.get('profile.firstName'),
                isVisible: tradeMessageStore.canShowMessage()
            };
        }));

        ReactDOM.render(React.createElement(component, {
            context: context.getComponentContext()
        }), element);
    }
};



// WEBPACK FOOTER //
// ./assets/js/global/tradeWelcomeMessageHelper.es.js